import { Formik } from "formik";
import { useState } from "react";
import { Accordion, Button, Col, Form, Row, Spinner } from "react-bootstrap";
import * as Yup from "yup";
import FareZoneService from "../../services/FareZoneService";

interface FareChangesReportAccordianProps {
  fareZoneService: FareZoneService;
}

interface FormValues {
  fareChangesSnapshot: string;
}

const FareChangesReportAccordian = ({
  fareZoneService,
}: FareChangesReportAccordianProps) => {
  const [isLoading, setIsLoading] = useState(false);

  const initialValues = {
    fareChangesSnapshot: new Date(
      new Date().setFullYear(new Date().getFullYear() - 1)
    )
      .toISOString()
      .split("T")[0],
  } as FormValues;

  const fareChangesSchema = Yup.object().shape({
    fareChangesSnapshot: Yup.date().required("Required"),
  });

  const handleFareChangesExport = (values: FormValues) => {
    setIsLoading(true);
    fareZoneService
      .GetFareChangesReport(new Date(values.fareChangesSnapshot))
      .then((response) => {
        const url = window.URL.createObjectURL(new Blob([response]));

        var snapshotString = values.fareChangesSnapshot.replace(/-/g, "");
        const link = document.createElement("a");
        link.href = url;
        link.setAttribute(
          "download",
          `fare_changes_report_from_${snapshotString}.csv`
        );
        document.body.appendChild(link);
        link.click();

        link.parentNode?.removeChild(link);
        window.URL.revokeObjectURL(url);
        setIsLoading(false);
      });
  };

  return (
    <>
      <Accordion.Item eventKey="FareChangesReport">
        <Accordion.Header>Fare Changes Report</Accordion.Header>
        <Accordion.Body>
          <p>
            Compares latest and historic fares by station indicating if they
            have been revised
          </p>
          <Formik
            initialValues={initialValues}
            onSubmit={(values) => handleFareChangesExport(values)}
            validationSchema={fareChangesSchema}
          >
            {({ values, handleSubmit, errors, touched, handleChange }) => (
              <Form onSubmit={handleSubmit}>
                <Row>
                  <Col md={6}>
                    <Form.Group className="mb-3" controlId="">
                      <Form.Label>Fares as at:</Form.Label>
                      <Form.Control
                        type="date"
                        value={values.fareChangesSnapshot}
                        onChange={handleChange}
                        name="fareChangesSnapshot"
                      />
                    </Form.Group>
                  </Col>
                </Row>
                <Button variant="primary" disabled={isLoading} type="submit">
                  {!isLoading && <div>Download</div>}
                  {isLoading && (
                    <>
                      Downloading...{" "}
                      <Spinner animation="border" role="status" size="sm" />
                    </>
                  )}
                </Button>
              </Form>
            )}
          </Formik>
        </Accordion.Body>
      </Accordion.Item>
    </>
  );
};

export default FareChangesReportAccordian;
